import { useTranslation } from "react-i18next";
import styled from "styled-components";
import TextField from "components/TextField";
import { IUserInfo } from "common/interfaces/IUserInfo";

interface UserInfoFormProps {
  setUserData: any;
  userData: IUserInfo;
}

const Wrapper = styled.div`
  width: 100%;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Text = styled.h2`
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 1.8rem;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  &:not(:last-child) {
    margin-bottom: 30px;
  }
`;

const UserInfoForm = ({ setUserData, userData }: UserInfoFormProps) => {
  const { t } = useTranslation("forms");
  const { name, username, email, confirmEmail, password, confirmPassword } =
    userData;

  return (
    <Wrapper>
      <Text>{t("registerDescription")}</Text>
      <Form>
        <Row>
          <TextField
            placeholder={t("name")}
            value={name ? name : ""}
            onChange={(value) => {
              setUserData({ ...userData, name: value });
            }}
            styles={{ marginRight: "50px" }}
          />
          <TextField
            placeholder={t("username")}
            value={username ? username : ""}
            onChange={(value) => {
              setUserData({ ...userData, username: value });
            }}
          />
        </Row>
        <Row>
          <TextField
            placeholder={t("email")}
            value={email ? email : ""}
            onChange={(value) => {
              setUserData({ ...userData, email: value });
            }}
            styles={{ marginRight: "50px" }}
          />
          <TextField
            placeholder={t("confirmEmail")}
            value={confirmEmail ? confirmEmail : ""}
            onChange={(value) => {
              setUserData({ ...userData, confirmEmail: value });
            }}
          />
        </Row>
        <Row>
          <TextField
            placeholder={t("password")}
            value={password ? password : ""}
            type="password"
            onChange={(value) => {
              setUserData({ ...userData, password: value });
            }}
            styles={{ marginRight: "50px" }}
          />
          <TextField
            placeholder={t("confirmPassword")}
            value={confirmPassword ? confirmPassword : ""}
            type="password"
            onChange={(value) => {
              setUserData({ ...userData, confirmPassword: value });
            }}
          />
        </Row>
      </Form>
    </Wrapper>
  );
};

export default UserInfoForm;
